import { makeAutoObservable, runInAction } from 'mobx';
import { IStatus, IStatusParams } from 'src/@types/Choqorak/Settings/Status';
import agent from 'src/api/agent';
export default class StatusStore {
  openDialog = false;

  StatusRegistry = new Map<number, IStatus>();

  editMode = false; //When click on edit button

  selectedStatus: IStatus | undefined = undefined;

  totalRecord: number = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get StatusList() {
    return Array.from(this.StatusRegistry.values());
  }

  setStatusList = (Status: IStatus) => {
    this.StatusRegistry.set(Status.id!, Status);
  };

  //Pagination
  loadStatus = async (params: IStatusParams) => {
    // this.StatusRegistry.clear();
    try {
      const result = await agent.Status.getList(params);
      runInAction(() => {
        this.totalRecord = result.data.totalRecord;
        const reversed = result.data.data.reverse();
        reversed.forEach((lst: any) => {
          this.setStatusList(lst);
        });
      });
    } catch (error) {
      console.log(error);
    }
  };

  // Search
  StatusSearch = async (params: IStatusParams) => {
    this.StatusRegistry.clear();
    this.loadStatus(params);
  };

  getStatusFromRegistry = (id: number) => {
    let Status = this.StatusRegistry.get(id);
    if (Status) {
      this.editMode = true;
      this.selectedStatus = Status;
    }
  };

  clearSelectedStatus = () => {
    this.editMode = false;
    this.selectedStatus = undefined;
  };

  deleteStatus = async (id: number, remark?: string) => {
    await agent.Status.delete(id, remark!);
    runInAction(() => {
      this.StatusRegistry.delete(id);
      this.totalRecord--;
      this.setOpenCloseDialog();
    });
  };

  setOpenCloseDialog = () => (this.openDialog = !this.openDialog);

  createStatus = async (Status: IStatus) => {
    await agent.Status.create(Status);
    runInAction(() => {
      this.loadStatus({ pageIndex: 0, pageSize: 5 });
      this.clearSelectedStatus();
    });
  };

  updateStatus = async (Status: IStatus) => {
    await agent.Status.update(Status);

    runInAction(() => {
      this.loadStatus({ pageIndex: 0, pageSize: 5 });
      this.StatusRegistry.delete(Status.id!);
      this.StatusRegistry.set(Status.id!, Status);
      this.clearSelectedStatus();
    });
  };
}
